export const SCHEDULE_OPTIONS = ["Yes", "No"];

// Column headings, as in the sheet. Also the CSV's columns.
export const COLUMNS = {
  storeCode: "DPI ID",
  storeName: "Store Name",
  deviceId: "deviceId",
  deviceName: "device Name",
  deviceType: "Device Type",
  toBeScheduled: "To be scheduled",
};

// How many stores' devices are read at once.
export const LOAD_CONCURRENCY = 6;
